export default __webpack_public_path__ + "static/media/microsoft-dynamics.ee561054.png";